import { Outlet, Navigate } from 'react-router-dom';
import { getSessionToken } from '../../utils/users';

export const PrivateRouter = () => {
	const hasLogged = !!getSessionToken();
	return hasLogged ? <Outlet /> : <Navigate to={`login`} />;
};
